import React from 'react'
import { useTranslation } from 'react-i18next'
import { useContact } from '../../context/ContactContext'
import './about.css'
import { FiArrowUpRight, FiCpu, FiUsers, FiClock, FiLayers, FiGlobe } from 'react-icons/fi'
import meAbout from '../../assets/me-about.png'

const About = () => {
  const { t } = useTranslation()
  const { openContact } = useContact()

  const stats = [
    { icon: FiClock, value: t('about.experienceValue'), label: t('about.experience') },
    { icon: FiLayers, value: t('about.projectsValue'), label: t('about.projects') },
    { icon: FiGlobe, value: t('about.clientsValue'), label: t('about.clients') },
  ]

  const highlights = [
    { icon: FiCpu, text: t('about.p2') },
    { icon: FiUsers, text: t('about.p3') },
  ]

  return (
    <section id="about" className="about-section">
      <div className="about-section__glow" aria-hidden="true" />
      <div className="container">
        <div className="section__header">
          <span className="section__label">{t('about.subtitle')}</span>
          <h2 className="section__title">{t('about.title')}</h2>
        </div>

        <div className="about__panel glass">
          <div className="about__stats">
            {stats.map(({ icon: Icon, value, label }) => (
              <div key={label} className="about__stat">
                <div className="about__stat-icon">
                  <Icon />
                </div>
                <span className="about__stat-label">{label}</span>
                <strong className="about__stat-value">{value}</strong>
              </div>
            ))}
          </div>

          <div className="about__body">
            <div className="about__content">
              <p className="about__lead">{t('about.p1')}</p>

              <ul className="about__highlights">
                {highlights.map(({ icon: Icon, text }) => (
                  <li key={text} className="about__highlight">
                    <div className="about__highlight-icon">
                      <Icon />
                    </div>
                    <p>{text}</p>
                  </li>
                ))}
              </ul>

              <button type="button" className="about__cta" onClick={openContact}>
                <span>{t('about.cta')}</span>
                <FiArrowUpRight />
              </button>
            </div>

            <div className="about__visual">
              <div className="about__brand">
                <div className="about__brand-glow" aria-hidden="true" />
                <img src={meAbout} alt="UNICodes" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
